import * as React from 'react';
import { cn } from '../../utils/utils';

const Error = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('flex flex-col w-full h-full justify-center items-center space-y-3', className)}
        {...props}
    />
));
Error.displayName = 'Error';

const ErrorIcon = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
    <div className={cn('', className)} {...props} />
);
ErrorIcon.displayName = 'ErrorIcon';

const ErrorTitle = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
    <div
        className={cn('max-w-[80%] md:max-w-1/2 self-center text-lg font-poppins font-semibold text-center', className)}
        {...props}
    />
);
ErrorTitle.displayName = 'ErrorTitle';

const ErrorDescription = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
    <div
        className={cn(
            'max-sm:max-w-[80%] md:max-w-lg text-sm font-poppins text-center text-muted-foreground',
            className,
        )}
        {...props}
    />
);
ErrorDescription.displayName = 'ErrorDescription';

const ErrorCTA = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
    <div className={cn('mt-2', className)} {...props} />
);
ErrorCTA.displayName = 'ErrorCTA';

// Export individual
export { Error, ErrorIcon, ErrorTitle, ErrorDescription, ErrorCTA };
